"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    tooltipWrapper: {
        display: 'inline-block'
    },
    infoTooltipBody: {
        borderRadius: 5,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: 0.1,
        wordBreak: 'break-word',
        whiteSpace: 'pre-line',
        lineHeight: '20px',
        '& strong': {
            fontWeight: 800
        }
    },
    infoTooltipArrowUp: {
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderBottomWidth: 6,
        borderBottomStyle: 'solid'
    }
};
//# sourceMappingURL=infoTooltip.style.js.map